import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class WorkerService {
	createWorkerExcel() {
		// if you change this line make sure that you change similar line inside gulp file
		return new Worker(new URL('../workers/export-excel.worker', import.meta.url), { type: 'module' });
	}

	readExcelWorker() {
		return new Worker(new URL('../workers/read-excel.worker', import.meta.url), { type: 'module' });
	}
}
